import { useEditDashboardFolderModalModel } from './edit-dashboard-folder-modal.model'
import type { IBaseEditDashboardFolderModalProps } from './edit-dashboard-folder-modal.types'
import { EditDashboardFolderModalView } from './edit-dashboard-folder-modal.view'

export const EditDashboardFolderModal = ({ isOpen }: IBaseEditDashboardFolderModalProps) => {
  const editDashboardFolderModalModel = useEditDashboardFolderModalModel()
  return <EditDashboardFolderModalView isOpen={isOpen} {...editDashboardFolderModalModel} />
}
